export const sanitizeString = (string: string, delimiter = '-', forceLowerCase = true) => {
  let output = '';

  if (typeof string === 'string' && string) {
    output = string.trim().replace(/\s+/g, delimiter);

    if (forceLowerCase) {
      output = output.toLowerCase();
    }
  }
  else if (typeof string === 'number' && Number.isFinite(string)) {
    output = `${string}`;
  }

  return output;
};
